import React from 'react';
import HarryUI from '@/components/HarryUI';

export default function HarryUIDemo() {
  return <HarryUI />;
}
